import ReactModal from "react-modal";
import { BoxModal } from "../../../components/boxModal";

import './styles.css'
import { Controller, set, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Input } from "../../../components/Input";
import Select from 'react-select';
import { apiV1 } from "../../../lib/axios";
import { useEffect, useState } from "react";
import { useAuth } from "../../../hooks/useAuth";
import { sendTransactionMfa } from "../../../services/mfa.service";

const createAccessFormSchema = z.object({
  name: z.string(),
  email: z
    .string()
    .refine(
      (val) => val === '' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
      { message: 'Email inválido' }
    ),
  phone: z.string(),
  newPassword: z
    .string()
    .min(8, { message: 'A senha deve ter pelo menos 8 caracteres' })
    .refine(
      (value) =>
        /[A-Z]/.test(value) &&
        /[a-z]/.test(value) &&
        /[0-9]/.test(value) &&
        /[^A-Za-z0-9]/.test(value),
      {
        message:
          'A senha deve conter ao menos uma letra maiúscula, uma minúscula, um número e um caractere especial',
      }
    ),
  permissions: z.array(z.string()).min(1, { message: 'Selecione pelo menos uma permissão' }),
})
export function CreateAccessModal({ isOpen, setCreateAccessModal, createCompanyUser, companyUserLoading }) {
  const [permissions, setPermissions] = useState([]);
  const [step, setStep] = useState('form');
  const [formDataPreview, setFormDataPreview] = useState(null);
  const [mfaCode, setMfaCode] = useState('');

  const { user } = useAuth();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    resolver: zodResolver(createAccessFormSchema),
  })

  const getPermissions = async () => {
    const result = await apiV1.get('/permissions');
    setPermissions(result.data.permissions.map(permission =>
    ({
      value: permission.id,
      label: permission.label
    })
    ));
  }

  const handleFormSubmit = (data) => {
    setFormDataPreview(data);
    setStep('preview');
    sendTransactionMfa();
  };

  const confirmMfaAndSave = async () => {
    await createCompanyUser({
      ...formDataPreview,
      otp: mfaCode,
    });
    setStep('form');
  }

  useEffect(() => {
    getPermissions();
  }, []);

  return (
    <ReactModal isOpen={isOpen} className="change-modal" overlayClassName="overlay-change-password-modal">
      <BoxModal title='Criar novo acesso' maxWidth={550} close={() => setCreateAccessModal(false)}>
        {
          step === 'form' &&
          (
            <form onSubmit={handleSubmit(handleFormSubmit)}>
              <div className="form-section">
                <div className="input-group d-flex flex-column mb-3">
                  <Input
                    type="text"
                    label="Nome"
                    register={register('name')}
                    isRequired
                  />
                  {errors.name && <span className="text-danger">{errors.name.message}</span>}
                </div>

                <div className="input-group d-flex flex-column mb-3">
                  <Input
                    type="text"
                    label="Telefone"
                    maxLength={11}
                    onlyNumber
                    register={register('phone')}
                    isRequired
                  />
                  {errors.phone && <span className="text-danger">{errors.phone.message}</span>}
                </div>

                <div className="input-group d-flex flex-column mb-3">
                  <Input
                    type="text"
                    label="Email"
                    register={register('email')}
                    isRequired
                  />
                  {errors.email && <span className="text-danger">{errors.email.message}</span>}
                </div>

                <div className="input-group d-flex flex-column mb-3">
                  <Input
                    type="password"
                    label="Senha"
                    register={register('newPassword')}
                    isRequired
                  />
                  {errors.newPassword && <span className="text-danger">{errors.newPassword.message}</span>}
                </div>

                <div className="input-group d-flex flex-column mb-3">
                  <label className="form-label">Permissões <span className="text-danger">*</span></label>

                  <Controller
                    name="permissions"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={permissions}
                        isMulti
                        placeholder="Selecione permissões..."
                        classNamePrefix="react-select"
                        onChange={(selectedOptions) => {
                          field.onChange(selectedOptions.map((opt) => opt.value));
                        }}
                        value={permissions?.filter(opt => field.value?.includes(opt.value))}
                      />
                    )}
                  />
                  {errors.permissions && <span className="text-danger">{errors.permissions.message}</span>}
                </div>
              </div>

              <div className="button-group mt-4 d-flex justify-content-between">
                <button className="btn btn-outline-secondary col-5" type="button" onClick={() => setCreateAccessModal(false)}>Cancelar</button>
                <button className="btn btn-success col-5" type="submit">Confirmar</button>
              </div>
            </form>
          )
        }
        {
          step === 'preview' && (
            <div className="mfa-confirmation-step">
              <h5>Confirme a criação do acesso</h5>
              <p>Enviamos um código por SMS para {user?.phoneNumber}</p>
              <div className="comparison">
                <div><strong>Nome:</strong> {formDataPreview.name}</div>
                <div><strong>Telefone:</strong> {formDataPreview.phone}</div>
                <div><strong>Email:</strong> {formDataPreview.email}</div>
              </div>
              <div className="d-flex flex-column my-3">
                <label>Código MFA</label>
                <input
                  className="form-control"
                  value={mfaCode}
                  onChange={(e) => setMfaCode(e.target.value)}
                  maxLength={6}
                  placeholder="Digite o código recebido"
                />
              </div>
              <div className="d-flex justify-content-between mt-3">
                <button className="btn btn-outline-secondary col-5" onClick={() => companyUserLoading ? null : setStep('form')} disabled={companyUserLoading}>Voltar</button>
                <button className="btn btn-success col-5" onClick={companyUserLoading ? null : confirmMfaAndSave} disabled={companyUserLoading}>{companyUserLoading ? "Criando..." : "Criar"}</button>
              </div>
            </div>
          )
        }


      </BoxModal>
    </ReactModal>
  )
}